import _ from "lodash"

import { HTTP_METHODS } from "./../../../../../constants"
import { makeExternalCall } from "./../../../../../helpers"
import { isRLTLang } from "../../../../../i18n"


const FETCH_OPTIONS_ENDPOINT = "/api/pa/options/list?list_number=4"

const formatOptions = (options) => options.map((option) => (
  { label: isRLTLang() ? option.valueAr : option.valueFr, value: option.rank }))


export const basicUtilitiesUIHelper = (callback, keyword) => {

  let endpoint = FETCH_OPTIONS_ENDPOINT
  let query = {}
  if (!_.isEmpty(keyword)) {
    query = { q: keyword }
  }

  return new Promise((resolve, reject) =>
    makeExternalCall(HTTP_METHODS.GET, endpoint, {}, {}, query)
      .then(resp => {
        let result = {}
        if (_.isPlainObject(resp.data)) {
          result = [resp.data]
        } else {
          result = resp.data
        }
        resolve(callback(formatOptions(result)))
      })
      .catch(err => reject(err.response))
  )
}





/* export const BASIC_UTILITIES = { 
    1: "BASIC_UTILITIES.AVAILABLE",
    2: "BASIC_UTILITIES.IMPERFECT",
    3: "BASIC_UTILITIES.NOT_AVAILABLE",
  }
  
export const basicUtilitiesUIHelper = (intl) =>
    Object.keys(BASIC_UTILITIES).map((key) => ({
      value: parseInt(key),
      label: intl.formatMessage({ id: BASIC_UTILITIES[key] }),
    })) */
  
